import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useFindAreasHook from "@/shared/hooks/useFindAreasHook";
import Select from "../Select/Select";
import usePosOrderUser from "@/shared/atoms/usePosOrderUser";

const Area = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const [orderUser] = usePosOrderUser();
  const areas = useFindAreasHook(orderUser?.zip_code ?? "");

  return (
    <Controller
      name="order_user.area"
      control={control}
      defaultValue={orderUser?.area || areas[0]}
      render={(props) => {
        const options = areas.map((area) => ({
          label: area,
          value: area,
        }));
        return (
          <Select
            label={t("posOrders.area")}
            onChange={(v) => props.onChange(v.value)}
            value={options?.find((i) => i.value === props.value)}
            options={options}
          />
        );
      }}
    />
  );
};

export default Area;
